import { useState, createContext } from 'react';
import { create, MediaPlayer } from 'amazon-ivs-player';

const ResourcePoolContext = createContext<ResourcePool |null>(null);

export { ResourcePoolContext };

// core is a structure added on during the ivs create
// function that isn't typed in the amazon player for
// some weird reason, so extending here.
export interface IvsMediaPlayer extends MediaPlayer {
	core?: {
		id: number;
	}
}
export interface ObjectPoolMember {
    data: IvsMediaPlayer;
    free: boolean;
    index: number;
}

export interface ResourcePool {
    getElement: Function;
	releaseElement: Function;
}

const workerPath: any = process.env.REACT_APP_WASM_WORKER_PATH;
const binaryPath: any = process.env.REACT_APP_WASM_BINARY_PATH;

const UseResourcePool = (): ResourcePool => {
	const [ivsPlayerPool, setIvsPlayerPool] = useState<Array<ObjectPoolMember>>([]);

	const createElement = () => {
		const ivsPlayer = create({
			wasmWorker: workerPath,
			wasmBinary: binaryPath,
		}) as IvsMediaPlayer;
		const newElement:ObjectPoolMember = {
			data: ivsPlayer,
			free: true,
			index: ivsPlayer.core!.id,
		};
		return newElement;
	};

	const getElement = ():ObjectPoolMember => {
		for (let i = 0; i < ivsPlayerPool!.length; i += 1) {
			if (ivsPlayerPool?.[i]?.free) {
				ivsPlayerPool![i].free = false;
				return ivsPlayerPool![i];
			}
		}
		const newObject = createElement();
		newObject.free = false;
		setIvsPlayerPool((prevPool) => [...prevPool, newObject]);
		return newObject;
	};

	const releaseElement = (elementIndex:number) => {
		if (elementIndex || elementIndex === 0) {
			setIvsPlayerPool((prevPool) => prevPool.map((elm) => {
				if (elm.data.core?.id === elementIndex) {
					elm.data.pause();
					return {
						data: elm.data,
						free: true,
						index: elementIndex,
					};
				}
				return elm;
			}));
		}
	};

	const resourcePool = {
		getElement,
		releaseElement,
	};
	return resourcePool;
};

export default UseResourcePool;
